<script lang="ts" setup>
import { titles } from '@/models/statistics.model';
import { useRoute } from 'vue-router';

const route = useRoute();
</script>
<template>
  <v-app-bar app>
    <v-breadcrumbs
      :items="['Statistics', titles[route.params.slug as string] ]"
    />
  </v-app-bar>
</template>
<style>
.v-toolbar {
  z-index: 100 !important;
}
</style>
